import { onCleanup } from './cleanup.js'

function modal () {
  const html = document.querySelector('html')
  const modaLinks = document.querySelectorAll('.open-modal')
  const btnClose = document.querySelectorAll('.modal .close')
  const allModals = document.querySelectorAll('.modal')

  function closeModal (modal) {
    html.dataset.modal = 'off'
    modal.dataset.show = 'off'
  }

  /**
   * Detiene la reproducción del contenido embebido al cerrar el modal.
   * @param {HTMLElement} modal
   */
  function stopMedia (modal) {
    const video = modal.querySelector('video')
    if (video) video.pause()

    // Vaciar el src es la única forma de frenar un iframe de video
    const iframe = modal.querySelector('iframe')
    if (iframe && iframe.getAttribute('src')) {
      iframe.setAttribute('src', '')
    }
  }

  // Función para manejar el clic fuera del elemento
  function handleClickOutside (modal, modalContent, event) {
    if (!modalContent.contains(event.target)) {
      // console.log('Se hizo clic fuera del elemento.');
      stopMedia(modal)
      closeModal(modal)
    }
  }

  modaLinks.forEach((btnModal) => {
    // Asignación (no addEventListener): no se acumula entre inicializaciones
    btnModal.onclick = (e) => {
      e.preventDefault()
      e.stopPropagation() // Detiene la propagación del evento

      /* open modal */
      const modaLink = btnModal.dataset.modal

      const modal = document.querySelector(
        '.modal[data-modal=' + modaLink + ']'
      )

      if (!modal) return

      const modalType = modal.dataset.type
      html.dataset.modal = 'on'
      modal.dataset.show = 'on'

      /* video play */
      if (modalType === 'video') {
        const modalVideo = modal.querySelector('video')
        if (modalVideo) modalVideo.play()
      }

      /* iframe play */
      if (modalType === 'iframe') {
        const modalIframe = modal.querySelector('iframe')
        if (modalIframe) {
          // Antes: modalIframe.set(...) → TypeError, los nodos DOM no tienen .set()
          modalIframe.setAttribute('src', modalIframe.dataset.src)
        }
      }
    } // click
  })

  // Cerrar Modal al clickear fuera del contenido
  allModals.forEach((modal) => {
    const onModalClick = (event) => {
      const modalContent = modal.querySelector('.modal-box')
      if (!modalContent) return
      handleClickOutside(modal, modalContent, event)
    }

    modal.addEventListener('click', onModalClick)
    onCleanup(() => modal.removeEventListener('click', onModalClick))
  })

  // Cerrar Modal al clickear el botón cerrar
  btnClose.forEach((close) => {
    const onCloseClick = (e) => {
      e.preventDefault()

      const thisModal = close.closest('.modal')
      if (!thisModal) return

      stopMedia(thisModal)
      thisModal.dataset.show = 'off'

      setTimeout(() => {
        html.dataset.modal = 'off'
      }, 300)
    }

    close.addEventListener('click', onCloseClick)
    onCleanup(() => close.removeEventListener('click', onCloseClick))
  })
}

export default modal
